module.exports = __webpack_public_path__ + "img/nt85-05-82-1.prt.abc5f44d.jpg";